import { useLocation } from "react-router-dom";
import Button from "../../components/common/button";
import Spinner from "../../components/common/Spinner";
import { useGetUserPermission } from "../../context/AuthStaffUserContext";
import Tabs from "../../components/common/Tabs";
import TabPanel from "../../components/common/Tabs/TabPanel";
import useGetComponentsQuery from "../../hooks/use-get-components";
import DynamicViewLayout from "./components";
import AddCategoryModal from "./components/AddCategoryModal";
import { useState } from "react";
import { EditSvg } from "../../icons";


const Staff: React.FC = () => {
    const location = useLocation();
    const [isCategoryModalOpen, setIsCategoryModalOpen] = useState(false);
    const [isEditCategory, setIsEditCategory] = useState(false);
    const { data: componentsData, isLoading: isGetDepartmentLoading, refetch } =
        useGetComponentsQuery({ hotelId: localStorage.getItem("hotelId") || "c102" });

    const components = componentsData?.result?.data?.cateogry || [];

    // const departmentsData = data?.result?.data?.departmentsData;

    const { write: isEditPermission } = useGetUserPermission("staff");

    const handleCategorySuccess = () => {
        refetch();
    };

    if (isGetDepartmentLoading) {
        return <Spinner fullScreenOverlay className="z-[100]" />;
    }

    const tabs = components
        .filter(component => component.isVisible !== false)
        .sort((a, b) => a.viewRank - b.viewRank)
        .map(component => ({
            value: component.categoryName,
            name: component.displayName,
        }));

    // Get default tab from URL path
    const getDefaultTab = () => {
        const path = location.pathname;
        if (path.includes('/services/essentials')) return 'Essentials';
        if (path.includes('/services/dining')) return 'Dining';
        if (path.includes('/services/services')) return 'Services';
        return tabs[0]?.value;
    };

    return (
        <div className="p-2 mt-0 pt-0 min-h-full">
            <div className="flex justify-end items-center">
                {/* <h2 className="text-xl text-[#1E2F65] "></h2> */}
                <Button
                    disabled={!isEditPermission}
                    variant="primary"
                    className="w-auto h-9"
                    onClick={() => setIsCategoryModalOpen(true)}
                >
                    Add New Category
                </Button>
                <div
                    className="h-8 w-8 rounded-full bg-[#EFF6FF] flex items-center justify-center cursor-pointer ml-1 hover:bg-[#DBEAFE] transition-colors"
                    onClick={() => {
                        setIsCategoryModalOpen(true)
                        setIsEditCategory(true)
                    }}
                >
                    <EditSvg color="#2563EB" />
                </div>
            </div>
            <div className="mt-1">
                <Tabs
                    tabs={tabs}
                    defaultValue={getDefaultTab()}
                    key={location.pathname}
                >
                    {components.map(component => (
                        <TabPanel key={component._id} value={component.categoryName}>
                            <DynamicViewLayout
                                componentName={component.displayName}
                                componentData={componentsData?.result?.data?.component[component.categoryName]}
                                allComponentsData={componentsData?.result?.data}
                                refetchComponents={refetch}
                            />
                        </TabPanel>
                    ))}
                </Tabs>
            </div>

            <AddCategoryModal
                isOpen={isCategoryModalOpen}
                isEditCategory={isEditCategory}
                closeModal={() => {
                    setIsCategoryModalOpen(false);
                    setIsEditCategory(false);
                }}
                onSuccess={handleCategorySuccess}
            />
        </div>
    );
};

export default Staff;
